<template>
  <div class="welcome">
    <div v-if="status === 0">
      <p v-if="locale === 'en'">{{ $t('admin-judge/welcome1') }} {{ user && user.lastname }} {{ user && user.firstname }}</p>
      <p v-if="locale !== 'en'">{{ $t('admin-judge/welcome0') }} {{ user && user.lastname }} {{ user && user.firstname }} {{ $t('admin-judge/welcome1') }}</p>
      <p>{{ $t('admin-judge/welcome2') }}</p>
      <!-- <p>{{ $t('admin-judge/welcome3') }}</p> -->
      <p>{{ $t('admin-judge/welcome4') }}</p>
      <p>{{ $t('admin-judge/welcome5') }}</p>
      <p>{{ $t('admin-judge/welcome6') }}</p>
      <p>{{ $t('admin-judge/welcome7') }}</p>
      <p>
        {{ $t('admin-judge/welcome8') }}
        <span v-if="countdownText" class="countdown">
          ({{ countdownText }})
        </span>
      </p>
      <p>{{ $t('admin-judge/welcome9') }}</p>
      <p>{{ $t('admin-judge/welcomeTel') }}</p>
      <p>{{ $t('admin-judge/welcomeEmail') }}</p>
      <p>{{ $t('admin-judge/welcomeEmail2') }}</p>
    </div>
    <!-- <div v-if="status === 1">
      <p v-if="locale === 'en'">{{ $t('admin-judge/welcome1') }} {{ user && user.lastname }} {{ user && user.firstname }}</p>
      <p v-if="locale !== 'en'">{{ user && user.lastname }} {{ user && user.firstname }} {{ $t('admin-judge/welcome1') }}</p>
      <p>{{ $t('admin-judge/welcome10') }}</p>
      <p>{{ $t('admin-judge/welcome11') }}</p>
      <p>{{ $t('admin-judge/welcomeTel') }}</p>
      <p>{{ $t('admin-judge/welcomeEmail') }}</p>
    </div>
    <div v-if="status === 2">
      <p v-if="locale === 'en'">{{ $t('admin-judge/welcome1') }} {{ user && user.lastname }} {{ user && user.firstname }}</p>
      <p v-if="locale !== 'en'">{{ user && user.lastname }} {{ user && user.firstname }} {{ $t('admin-judge/welcome1') }}</p>
      <p>{{ $t('admin-judge/welcome12') }}</p>
      <p>{{ $t('admin-judge/welcome13') }}</p>
      <p>{{ $t('admin-judge/welcome14') }}</p>
      <p>{{ $t('admin-judge/welcome15') }}</p>
      <p>{{ $t('admin-judge/welcome11') }}</p>
      <p>{{ $t('admin-judge/welcomeTel') }}</p>
      <p>{{ $t('admin-judge/welcomeEmail') }}</p>
    </div> -->
    <div v-if="status > 0">
      <p v-if="locale === 'en'">{{ $t('admin-judge/welcome1') }} {{ user && user.lastname }} {{ user && user.firstname }}</p>
      <p v-if="locale !== 'en'">{{ user && user.lastname }} {{ user && user.firstname }} {{ $t('admin-judge/welcome1') }}</p>
      <p>
        {{ $t('admin-judge/welcome17') }}
        <span v-if="disputeCountdownText" class="countdown">
          ({{ disputeCountdownText }})
        </span>
      </p>
      <p>{{ $t('admin-judge/welcome11') }}</p>
      <p>{{ $t('admin-judge/welcomeTel') }}</p>
      <p>{{ $t('admin-judge/welcomeEmail') }}</p>
      <p>{{ $t('admin-judge/welcomeEmail2') }}</p>
    </div>
  </div>
</template>

<script>
import { reviewsStart } from '@/api/judge'

export default {
  data() {
    return {
      status: -1, // 0-初评开始、1-初评完成初评、2-复评开始、3-初评完成复评
      countdownText: '',
      countdownTimer: null,
      disputeCountdownText: '',
      disputeCountdownTimer: null
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    user() {
      return this.$store.getters.user
    }
  },
  mounted() {
    reviewsStart().then(res => {
      this.status = res.status
    })
    this.startCountdown()
    this.startDisputeCountdown()
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
    if (this.disputeCountdownTimer) {
      clearInterval(this.disputeCountdownTimer)
    }
  },
  methods: {
    /**
     * 开始倒计时
     */
    startCountdown() {
      // 设置初评截止时间为2025年9月26日晚上11点（北京时间）
      const deadline = new Date('2025-09-26T23:00:00+08:00')

      const updateCountdown = () => {
        const now = new Date()
        const timeLeft = deadline - now

        if (timeLeft <= 0) {
          this.countdownText = this.$t('admin-judge/countdownExpired')
          clearInterval(this.countdownTimer)
          return
        }

        // 计算剩余时间
        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24))
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000)

        // 根据语言显示不同的倒计时文本
        if (this.locale === 'en') {
          this.countdownText = `${days}${this.$t('admin-judge/countdownDays')} ${hours}${this.$t('admin-judge/countdownHours')} ${minutes}${this.$t('admin-judge/countdownMinutes')} ${seconds}${this.$t('admin-judge/countdownSeconds')}`
        } else {
          this.countdownText = `${this.$t('admin-judge/countdownRemaining')}${days}${this.$t('admin-judge/countdownDays')}${hours}${this.$t('admin-judge/countdownHours')}${minutes}${this.$t('admin-judge/countdownMinutes')}${seconds}${this.$t('admin-judge/countdownSeconds')}`
        }
      }

      // 立即执行一次
      updateCountdown()

      // 每秒更新一次
      this.countdownTimer = setInterval(updateCountdown, 1000)
    },
    /**
     * 开始争议作品回复倒计时
     */
    startDisputeCountdown() {
      // 设置争议作品回复截止时间为2025年12月31日晚上18点（北京时间）
      const deadline = new Date('2025-12-31T18:00:00+08:00')

      const updateDisputeCountdown = () => {
        const now = new Date()
        const timeLeft = deadline - now

        if (timeLeft <= 0) {
          this.disputeCountdownText = this.$t('admin-judge/countdownExpired')
          clearInterval(this.disputeCountdownTimer)
          return
        }

        // 计算剩余时间
        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24))
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000)

        // 根据语言显示不同的倒计时文本
        if (this.locale === 'en') {
          this.disputeCountdownText = `${days}${this.$t('admin-judge/countdownDays')} ${hours}${this.$t('admin-judge/countdownHours')} ${minutes}${this.$t('admin-judge/countdownMinutes')} ${seconds}${this.$t('admin-judge/countdownSeconds')}`
        } else {
          this.disputeCountdownText = `${this.$t('admin-judge/countdownRemaining')}${days}${this.$t('admin-judge/countdownDays')}${hours}${this.$t('admin-judge/countdownHours')}${minutes}${this.$t('admin-judge/countdownMinutes')}${seconds}${this.$t('admin-judge/countdownSeconds')}`
        }
      }

      // 立即执行一次
      updateDisputeCountdown()

      // 每秒更新一次
      this.disputeCountdownTimer = setInterval(updateDisputeCountdown, 1000)
    }
  }
}
</script>

<style scoped>
.countdown {
  color: #ff4d4f;
  font-weight: bold;
  margin-left: 8px;
}
</style>
